import { smBuildingHeight } from 'projectDesign/components/projectConfiguration/fields/buildingHeight';
import clientName from 'projectDesign/components/projectConfiguration/fields/clientName';
import clientAddress from 'projectDesign/components/projectConfiguration/fields/clientAddress';
import elevation from 'projectDesign/components/projectConfiguration/fields/elevation';
import rafterSpacing from 'projectDesign/components/projectConfiguration/fields/rafterSpacing';
import railDirection from 'projectDesign/components/projectConfiguration/fields/railDirection';
import nxtRailFinish from 'projectDesign/components/projectConfiguration/fields/nxtRailFinish.json'
import frameSizeUp from 'projectDesign/components/projectConfiguration/fields/helioscope_frame_size_up.json';
import frameSizeWide from 'projectDesign/components/projectConfiguration/fields/helioscope_frame_size_wide.json';
import { nhRoofType } from 'projectDesign/components/projectConfiguration/fields/roofType';
import orientation from 'projectDesign/components/projectConfiguration/fields/helioscope_orientation.json';
import racking from 'projectDesign/components/projectConfiguration/fields/helioscope_racking.json';
import seismicSds from 'projectDesign/components/projectConfiguration/fields/seismicSds';
import seismicSs from 'projectDesign/components/projectConfiguration/fields/seismicSs';
import tornadoSpeed from 'projectDesign/components/projectConfiguration/fields/tornadoSpeed';
import setSpacing from 'projectDesign/components/projectConfiguration/fields/helioscope_setback.json';
import {SmAndNxtSnowLoadConfig} from 'projectDesign/components/projectConfiguration/fields/snowLoad';
import span from 'projectDesign/components/projectConfiguration/fields/span';
import {WindExposure} from 'projectDesign/components/projectConfiguration/fields/windExposure';
import { asce705WindSpeedForSfmAndSm, asce710WindSpeedForSfmAndSm, asce716WindSpeedForSfmAndSm_nxt } from 'projectDesign/components/projectConfiguration/fields/windSpeed';
import { checkEnvironmentalFactors } from 'projectDesign/components/projectConfiguration/utils/checkEnvironmentalFactors';
import { checkRafterSpacing, checkSeismic, checkShortestBuildingLength, checkBuildingHeight, checkSeismicSds, checkTornadoSpeed, checkFieldNotEmpty, checkRoofTypeMissing, checkPreferredSpan } from '__editor/components/roofsSelector/components/roofsSelectorSaveLoadProject/utils/validateProject';
import { state } from '__common/store';
import { getASCE716722BuildingDescriptionResidentalAdditionalInputs } from '../fields/getASCE716BuildingDescriptionResidentalAdditionalInputs';
import { getASCE716722LocationsResidentalAdditionalInputs } from '../fields/getASCE716LocationsResidentalAdditionalInputs';
import { isASCE705, isASCE710 , isASCE722} from '__common/constants/buildingCodes';
import { nhMidAndEndClamps } from 'projectDesign/components/projectConfiguration/fields/smClamps';
import smStandardSeamMetalAttachment from '../fields/smStandardSeamMetalAttachment';
import { railClampOption, NXTRailClampOption } from '../fields/railClampOption';
import roofMaterialThicknessSolarMountFlush, { rpanelRoofMaterialThicknessForPM9000s, rpanelRoofMaterialThicknessForPMAdj } from '../fields/roofMaterialThicknessSolarMountFlush';
import smSolarhooksAttachments from '../fields/smSolarhooksAttachments';
import topographicalFactorKzt from '../fields/topographicalFactorKzt';
import { AttachmentType, smAndNxtAttachmentTypes } from '../fields/attachmentType';
import { isOsbOrPlywood } from '../utils/validation';
import { roofSubstrate } from '../fields/roofSubstrate';
import { asce722BuildingCodeNXTUmount, asceBuildingCodeNHForAurora } from '../fields/buildingCode';
import { smTileReplacementsOrSolarhooks, TileAttachmentType } from '../fields/smTileReplacementsOrSolarhooks';
import { RoofType,TileReplacementOrSolarhooks, removeUpslopeRail } from '../utils/constants';
import azimuth from 'projectDesign/components/projectConfiguration/fields/helioscope_azimuth.json';
import { riskCategoryCheckForTornadoSpeed } from '../constraints/constraints';
import longestBuildingLength from '../fields/longestBuildingLength';
import riskCategory from '../fields/riskCategory';
import StaggerAttachments from 'projectDesign/components/projectConfiguration/fields/staggerAttachments';
import { PSEUDO_STAFF_USER_PERMISSIONS } from 'user/userGroups';
import auroraRackingType from '../fields/auroraRackingType';
import { getProjectRoofs } from 'projectDesign/components/asce716switch/asce716switch';
import getS5manufacturer from '../fields/s5RoofManufacturerField'
import domesticMLPERequired from '../fields/isDomesticMLPERequired';
import standoffHeight from '../fields/standoffHeight';
import osRackingType from '../fields/osRackingType';
import { isNxtHorizonHD, isNxtHorizonStandard } from '__common/constants/products';
import getS5RoofPanel from '../fields/s5RoofPanelField';
import getS5RoofMaterial from '../fields/s5RoofMaterialField';
import getS5Clamp from '../fields/s5ClampField';
import { extractUniqueS5Values, filterDataByFields, getNxtS5ClampOptions, getS5DataValue, isGeneric, s5AttachmentDictKeys, s5AttachmentPreferenceDict, s5AttachmentsData } from '../utils/s5AttachmentsFilters';
import s5Attachmentpreference from '../fields/s5AttachmentpreferenceField';
import { ascenderRailFinish} from '../fields/railFinish';

function getWindSpeedField(buildingCodeValue: number, isAurora: boolean, isOs: boolean = false) {
  if (isASCE705(buildingCodeValue)) {
    return asce705WindSpeedForSfmAndSm(isAurora, isOs);
  }

  if (isASCE710(buildingCodeValue)) {
    return asce710WindSpeedForSfmAndSm(isAurora, isOs);
  }

  return asce716WindSpeedForSfmAndSm_nxt(isAurora, isOs);
}

export default (buildingCodeValue: number) => {
  const {
    projectConfiguration: {
      projectEnvConfig: {
        seismic_ss, seismic_sds, tornado_speed, roof_type, 
        attachment_type, 
        roof_substrate,
        building_height,
        shortest_building_length,
        tile_replacement_or_solarhooks,
        rafter_spacing_inches, risk_category,
        building_length,
        snow_load,
        elevation: current_elevation,
        wind_speed,
        is_aurora_project,
        is_os_project,
        rail_clamp_option,
        topographical_factor_kzt,
        s5_roof_manufacturer,
        s5_roof_panel,
        s5_roof_material,
        s5_clamp,
        s5_or_sci,
        preferred_span,
      },
      productId, projectVersion, railsProductId
    },
    user :{
      isStaff, permissions
    }
  } = state();

  const roofs = getProjectRoofs();
  let isOneByTwelvePitch = () =>{
    if (roofs) {
      return Object.keys(roofs).some(roofKey => {
        const roofId = Number(roofKey)
        const roof: drawingManagerRoof = roofs[roofId]
        return roof.roofPitch === '1/12'        
      })
    }
  }

  const buildingCodeField = (is_aurora_project && isOneByTwelvePitch()) ? asceBuildingCodeNHForAurora() : asce722BuildingCodeNXTUmount(is_aurora_project, is_os_project);
  const windSpeed = getWindSpeedField(buildingCodeValue, is_aurora_project, is_os_project);
  const buildingHeight = smBuildingHeight(is_aurora_project, is_os_project);
  const roofType = nhRoofType
  const railFinish = isNxtHorizonHD(railsProductId) ? ascenderRailFinish: JSON.parse(JSON.stringify(nxtRailFinish)); 

  const rafterSpacingField = rafterSpacing(roof_type)

  const shouldShowS5AttachmentFields = (roof_type === RoofType.STANDING_SEAM) && (s5_or_sci === s5AttachmentPreferenceDict.s_5)

  let s5RoofManufacturer;
  let s5RoofPanel;
  let s5RoofMaterial;
  let s5Clamp;
  let selectedS5Manufacturer = s5_roof_manufacturer;
  let selectedS5Panel = s5_roof_panel;
  let selectedS5Material = s5_roof_material;
  let hasSelectedS5Manufacturer = false;
  let hasSelectedS5Panel = false;
  let hasSelectedS5Material = false;

  if(shouldShowS5AttachmentFields){
    selectedS5Manufacturer = getS5DataValue(s5AttachmentsData, s5AttachmentDictKeys.s_5_roof_manufacturer, s5_roof_manufacturer);
    const filteredMfValues = extractUniqueS5Values(s5AttachmentsData, s5AttachmentDictKeys.s_5_roof_manufacturer);
    filteredMfValues.unshift(isGeneric)
    s5RoofManufacturer = getS5manufacturer(filteredMfValues)

    const s5RoofPanelTypeData = filterDataByFields(s5AttachmentsData, (selectedS5Manufacturer === isGeneric) ? '' : {[s5AttachmentDictKeys.s_5_roof_manufacturer] : selectedS5Manufacturer})
    const filteredpanelTypeValues = extractUniqueS5Values(s5RoofPanelTypeData, s5AttachmentDictKeys.s_5_roof_panel_type)
    if(selectedS5Manufacturer === isGeneric) {
      filteredpanelTypeValues.unshift(isGeneric)
    }
    hasSelectedS5Manufacturer = checkFieldNotEmpty(selectedS5Manufacturer) && filteredpanelTypeValues.length > 0;
    s5RoofPanel = getS5RoofPanel(filteredpanelTypeValues)

    selectedS5Panel = getS5DataValue(s5RoofPanelTypeData, s5AttachmentDictKeys.s_5_roof_panel_type, s5_roof_panel);
    const s5RoofMaterialData = filterDataByFields(s5RoofPanelTypeData, (selectedS5Panel === isGeneric) ? ''  : {[s5AttachmentDictKeys.s_5_roof_manufacturer] : selectedS5Manufacturer, [s5AttachmentDictKeys.s_5_roof_panel_type] : selectedS5Panel,})
    const filteredRoofMaterialValues = extractUniqueS5Values(s5RoofMaterialData, s5AttachmentDictKeys.s_5_roof_material)
    if(selectedS5Panel === isGeneric){
      filteredRoofMaterialValues.unshift(isGeneric)
    }
    hasSelectedS5Panel = checkFieldNotEmpty(selectedS5Panel) && filteredRoofMaterialValues.length > 0;
    s5RoofMaterial = getS5RoofMaterial(filteredRoofMaterialValues)

    selectedS5Material = getS5DataValue(s5RoofMaterialData, s5AttachmentDictKeys.s_5_roof_material, s5_roof_material);
    const s5ClampData = filterDataByFields(s5RoofMaterialData, (selectedS5Material === isGeneric) ? '' : (selectedS5Manufacturer === isGeneric) ? {[s5AttachmentDictKeys.s_5_roof_material] : selectedS5Material} : {[s5AttachmentDictKeys.s_5_roof_manufacturer] : selectedS5Manufacturer, [s5AttachmentDictKeys.s_5_roof_panel_type] : selectedS5Panel, [s5AttachmentDictKeys.s_5_roof_material] : selectedS5Material})
    const filteredClampValues = getNxtS5ClampOptions(
      extractUniqueS5Values(s5ClampData, s5AttachmentDictKeys.s_5_clamp),
      rail_clamp_option === NXTRailClampOption.RAIL_CLAMP_ONLY,
    )
    hasSelectedS5Material = checkFieldNotEmpty(selectedS5Material) && filteredClampValues.length > 0;
    s5Clamp = getS5Clamp(filteredClampValues)
  }

  let tornadoSpeedsField:any = []
  let longestBuildingLengthField:any = []
  if (isASCE722(buildingCodeValue) && riskCategoryCheckForTornadoSpeed(risk_category)){
    tornadoSpeedsField = tornadoSpeed;
    longestBuildingLengthField = longestBuildingLength;
    longestBuildingLengthField.missing=!building_length
  }
  const seismicSdsField = isASCE722(buildingCodeValue) ? seismicSds : [];
  const snowLoad = SmAndNxtSnowLoadConfig(is_aurora_project, is_os_project);
  checkEnvironmentalFactors(buildingCodeField, windSpeed, snowLoad, seismicSs, elevation);
  
  rafterSpacingField.missing = !checkRafterSpacing(Number(rafter_spacing_inches));
  span.missing = !checkPreferredSpan(Number(preferred_span));
  seismicSs.missing = !checkSeismic(seismic_ss);
  seismicSds.missing = !checkSeismicSds(seismic_sds);
  tornadoSpeed.missing = !checkTornadoSpeed(tornado_speed);
  buildingHeight.missing = !checkBuildingHeight(building_height * 1);
  riskCategory.missing = !checkFieldNotEmpty(risk_category)
  snowLoad.missing = !checkFieldNotEmpty(snow_load);
  elevation.missing = !checkFieldNotEmpty(current_elevation);
  windSpeed.missing = !checkFieldNotEmpty(wind_speed);
  domesticMLPERequired.missing = !checkFieldNotEmpty(state().projectConfiguration?.projectEnvConfig?.is_domestic_mlpe_required);
  topographicalFactorKzt.missing = !checkFieldNotEmpty(topographical_factor_kzt);

  const shortestBuildingLengthMissing = !checkShortestBuildingLength(shortest_building_length * 1);
  roofType.missing = !checkRoofTypeMissing(roof_type);
  if(shouldShowS5AttachmentFields){
    s5RoofManufacturer.missing = !checkFieldNotEmpty(selectedS5Manufacturer);
    s5RoofPanel.missing = !checkFieldNotEmpty(selectedS5Panel);
    s5RoofMaterial.missing = !checkFieldNotEmpty(selectedS5Material);
    s5Clamp.missing = !checkFieldNotEmpty(s5_clamp);
  }
  s5Attachmentpreference.missing = !checkFieldNotEmpty(s5_or_sci);
  
  const Helioscope = {
      fields: [
        azimuth,
        frameSizeUp,
        frameSizeWide,
        orientation,
        racking,
        nhMidAndEndClamps('mid_clamps_choices','mid_clamps', true),
        nhMidAndEndClamps('end_clamps_choices','end_clamps', true),
      ],
  };
  const Aurora = {
    fields: [
      auroraRackingType,
      nhMidAndEndClamps('mid_clamps_choices','mid_clamps', true),
      nhMidAndEndClamps('end_clamps_choices','end_clamps', true),
    ],
};
  const Os = {
    fields: [
      osRackingType,
      nhMidAndEndClamps('mid_clamps_choices','mid_clamps', false, true),
      nhMidAndEndClamps('end_clamps_choices','end_clamps', false, true),
      asce722BuildingCodeNXTUmount(false, true)
    ],
};
  const cfg = {
    zipCode: 'zipcode',
    Area: 'Peoria, AZ',
    Helioscope,
    HelioscopeRoofPitchSelector:  true,
    Aurora,
    Os,
    Client: {
      label: '',
      fields: [
        clientName,
        clientAddress,
      ],
    },
    LocationAndLoads: {
      label: 'loads',
      fields: [
        buildingCodeField,
        WindExposure(is_os_project),
        windSpeed,
        snowLoad,
        elevation,
        seismicSs,
        seismicSdsField,
        ...getASCE716722LocationsResidentalAdditionalInputs(buildingCodeValue),
        topographicalFactorKzt,
        tornadoSpeedsField,
      ],
    },
    BuildingDescription: {
      label: 'Building description',
      fields: [
        buildingHeight,
        nhMidAndEndClamps('mid_clamps_choices','mid_clamps', false, is_aurora_project),
        nhMidAndEndClamps('end_clamps_choices','end_clamps', false, is_aurora_project),
        nhRoofType,
        ...(roof_type === RoofType.STANDING_SEAM ? [s5Attachmentpreference] : []),
        ...(shouldShowS5AttachmentFields ? [s5RoofManufacturer]: []),
        ...(shouldShowS5AttachmentFields && hasSelectedS5Manufacturer ? [s5RoofPanel] : []),
        ...(shouldShowS5AttachmentFields && hasSelectedS5Manufacturer && hasSelectedS5Panel ? [s5RoofMaterial] : []),
        ...(shouldShowS5AttachmentFields && hasSelectedS5Manufacturer && hasSelectedS5Panel && hasSelectedS5Material ? [s5Clamp] : []),
        ...(roof_type === RoofType.SHINGLE ? [smAndNxtAttachmentTypes(roof_type, productId)] : []) ,
        ...(roof_type === RoofType.SHINGLE  && [AttachmentType.FLASHLOC_DUO, AttachmentType.STRONGHOLD_ATT_BUTYL].includes(attachment_type)? [roofSubstrate(productId, attachment_type, roof_substrate, roof_type, railsProductId)] : []),
        isStaff || permissions.includes(PSEUDO_STAFF_USER_PERMISSIONS.staggering_access)?StaggerAttachments: [],
        ...(roof_type === RoofType.STANDING_SEAM && s5_or_sci == s5AttachmentPreferenceDict.sci ? [roofMaterialThicknessSolarMountFlush,smStandardSeamMetalAttachment] : []) ,
        ...(roof_type === RoofType.STANDING_SEAM ? [railClampOption] : []) ,
        ...(roof_type === RoofType.R_PANEL ? [smAndNxtAttachmentTypes(roof_type, productId), railClampOption] : []) ,
        ...(roof_type === RoofType.R_PANEL && [AttachmentType.PM_9000S, AttachmentType.NXT_S5_PROTEA_BRACKET_ASSEMBLY].includes(attachment_type) ? [rpanelRoofMaterialThicknessForPM9000s] : []) ,
        ...(roof_type === RoofType.R_PANEL && attachment_type === AttachmentType.PM_ADJUST ? [rpanelRoofMaterialThicknessForPMAdj] : []) ,
        ...(roof_type === RoofType.TILE ? [smTileReplacementsOrSolarhooks(productId, railsProductId)] : []) ,
        ...(roof_type === RoofType.TILE && tile_replacement_or_solarhooks === TileAttachmentType.SOLARHOOKS ? [smSolarhooksAttachments] : []) ,
        ...(roof_type === RoofType.TILE && tile_replacement_or_solarhooks === TileAttachmentType.STANDOFFS ? [standoffHeight] : []) ,
        ...getASCE716722BuildingDescriptionResidentalAdditionalInputs(buildingCodeValue, shortestBuildingLengthMissing, longestBuildingLengthField),
        domesticMLPERequired,
      ],
    },
  Spans: {
    label: '',
    fields: [
      span,
      isOsbOrPlywood(roof_type,attachment_type,roof_substrate) ? [] : rafterSpacingField,
    ],
  },
  railDirection: railDirection(removeUpslopeRail(attachment_type, projectVersion)),
  railFinish,
  railTypes: true,
};
  return cfg;
};
